import React, { useEffect } from 'react';
import './EmployeeDetailsContainer.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { t } from '../../functions/genericFunctions';
import axios from 'axios';
import { useCookies } from 'react-cookie';

function EmployeeDetailsContainer(props) {
    const profilePhotoRef = React.useRef();
    const [cookie, setCookie] = useCookies();

    let details = props.selectedEmployeeDetails;
    function formatDate(date) {
        let value = new Date(date);
        let yyyy = value.getFullYear();
        let mm = value.getMonth() + 1;
        let dd = value.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        let formattedDate = yyyy + '-' + mm + '-' + dd;
        return formattedDate;
    }

    function formatPhoneNumberInput(input) {
        try {
            input = input.toString();
            if (input.length > 0) {
                input = "(" + input;
                if (input.length > 2) {
                    input = input.slice(0, 3) + ") " + input.slice(3);
                }
                if (input.length > 9 && input.length <= 13) {
                    input = input.slice(0, 9) + " " + input.slice(9);
                }
                else if (input.length > 13) {
                    input = input.slice(0, 10) + " " + input.slice(10);
                }
                return input;
            }
        } catch (error) {
            return "";
        }


    }

    async function saveUserInDevice() {
        console.log("Starting Save Process...", details);
        try {
            let recordData = ""; // Python expects 'record', not 'photo'

            // Check if we have a valid picture URL
            if (details['picture'] && details['picture'].startsWith('http')) {
                try {
                    console.log("Fetching image from:", details['picture']);
                    
                    // 1. Fetch the image from the URL
                    const response = await fetch(details['picture']);
                    const blob = await response.blob();

                    // 2. Convert to Base64 using FileReader
                    const base64String = await new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                    });

                    // 3. Remove the header "data:image/jpeg;base64," to get raw data
                    if (base64String.includes(",")) {
                        recordData = base64String.split(',')[1];
                    } else {
                        recordData = base64String;
                    }
                    console.log("Image converted successfully. Length:", recordData.length);

                } catch (imgError) {
                    console.error("Could not convert image (CORS or Network issue):", imgError);
                    recordData = ""; 
                }
            }

            // 4. Send the RAW BASE64 data. 
            // CRITICAL: We are passing this as the 4th argument.
            // You must check the definition of 'props.saveUserToDevice' to ensure 
            // it maps this argument to the key 'record' and sets 'backupnum' to 50.
            props.saveUserToDevice(details['_id'], details['card']['card_id'], details['name'], recordData);

        } catch (error) {
            console.log("Error in saveUserInDevice:", error);
        }
    }

    function deleteEmployee(){
        props.deleteEmployee(details);
        console.log(details);
    }

    function setDefaultProfilePicture() {
        profilePhotoRef.current.src = "/images/Profile-Photo.png";
    }

    function setProfilePicture(imageUrl) {
        profilePhotoRef.current.src = imageUrl;
    }

    useEffect(() => {
        if (details != null) {
            setProfilePicture(details['picture']);
            if (details['picture'] && details['picture'] != "") {
                setProfilePicture(details['picture']);
            }
        }

        if ( props.webSocketConnFlag && details != null && details['card'] ){
            try {
                props.checkUserInDevice(details['card']['card_id']);
            } catch (error) {
                console.log(error);
            }
        }
        
        return () => {

        }
    }, [props.selectedEmployeeDetails, props.webSocketConnFlag ])

    

    return (
        <>
            {
                details != null && details != undefined ? <>
                    <div id="employeeDetailsContainer" className='employeeDetailsContainer'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='d-flex flex-row-reverse editEmployeeRow'>
                                    <img src="/icons/svg/Edit-Button.svg" onClick={props.toggleEditEmployeeModal} />
                                </div>

                            </div>
                            <div className='col-12'>
                                <div className='d-flex justify-content-center profilePhotoContainer'>
                                    <img ref={profilePhotoRef} src={"/images/Profile-Photo.png"} loading='lazy' onError={setDefaultProfilePicture} />
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='employeeDetailsTextArea'>
                                    <p>{t("employee_id")} - {details['employee_id']}</p>
                                    <p>{t("name")} - {details['name']}</p>
                                    <p>{t("rg_number")} - {details['rg_number']}</p>
                                    <p>{t("cpf_number")} - {details['cpf_number']}</p>
                                    <p>{t("civil_status")} - {details['civil_status'] ? t("married") : t("unmarried")}</p>
                                    <p>{t("address")} - {details['address']}</p>
                                    <p>{t("phone_number")} - {details['phone_number']['country_code'] + " " + formatPhoneNumberInput(details['phone_number']['number'])}</p>
                                    <p>{t("emergency_contact_number")} - {details['emergency_contact_number']['country_code'] + " " + formatPhoneNumberInput(details['emergency_contact_number']['number'])}</p>
                                    <p>{t("emergency_contact_name")} - {details['emergency_contact_person']}</p>
                                    <p>{t("number_of_children")} - {details['number_of_children']}</p>
                                    <p>{t("employment_date")} - {formatDate(details['employment_date'])}</p>
                                    <p>{t("ct_number")} - {details['ct_number']}</p>
                                    <p>{t("notes")} - {details['notes']}</p>
                                    <p>{t("remote_employee")} - {details['remote_employee'] ? t("yes") : t("no")}</p>
                                    <br />
                                </div>
                                <div className='row employeeDeviceActionArea'>
                                    <div className='col-12'>
                                        <div className='d-flex justify-content-end'>
                                            {
                                                props.employeeInDeviceState ? <>
                                                    <p className='userSavedInDevice'>User Saved in Device</p>
                                                </> : <>
                                                    <button onClick={saveUserInDevice} className='saveUserInDeviceButton' >Save User in Device</button>
                                                </>
                                            }
                                            <button className='deleteEmployeeButton' onClick={deleteEmployee}>Delete Employee</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </> : <></>
            }
        </>
    )
}

export default EmployeeDetailsContainer;